
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import MenuItemAddBtn from "./menu-item-add-btn.vue";
import menuNormalItemSection from "./menu-normal-item-section.vue";
import MenuNormalListBatchHeader from "./menu-normal-list-batch-header.vue";
import menuUpdateMenuBtn from "./menu-update-menu-btn.vue";
import MenuHeaderSearchField from "./menu-header-search-field.vue";
import RemoveModifyItemDialog from "../dialogs/remove-modify-item-dialog.vue";
import RemoveModifyCategoryDialog from "../dialogs/remove-modify-category-dialog.vue";
import CreateEditSubCategoryDialog from "../dialogs/create-edit-sub-category-dialog.vue";
import CreateEditCategoryDialog from "../dialogs/create-edit-category-dialog.vue";
import DeleteCategoryDialog from "../dialogs/delete-category-dialog.vue";

export default {
  components: {
    menuNormalItemSection,
    MenuItemAddBtn,
    MenuNormalListBatchHeader,
    menuUpdateMenuBtn,
    MenuHeaderSearchField,
    RemoveModifyItemDialog,
    RemoveModifyCategoryDialog,
    CreateEditSubCategoryDialog,
    CreateEditCategoryDialog,
    DeleteCategoryDialog
  },
  data() {
    return {
      panel: [0],
      subPanel: "",
      expandAll: false,
      expandAllSub: false,
      currentMinute: null,
      active: [],
      showExpansionContent: false,
      showCategoryOptionsDialog: false,
      selectedItem: "",
      selectedCategory: {},
      selectedSubCategory: {},
      showSubCategoryDialog: false,
      showCategoryDialog: false,
      showDeleteCategoryDialog: false,
      deleteLoading: false,
      timer: null
    };
  },
  props: {
    selectedGroupBy: "",
    selectedGroupByItem: "",
    selectedGroupBySubItem: "",
    groupedItems: [],
    highlightText: ""
  },
  created() {
    const $this = this;
    $this.setCurrentMinute();

    this.timer = setInterval(() => {
      $this.setCurrentMinute();
    }, 60000);
  },
  mounted() {
    this.setSelectedGroupByPanel(this.selectedGroupBy);
    this.setSelectedGroupByItemPanel(this.selectedGroupByItem);
    this.setSelectedGroupBySubItemPanel(this.selectedGroupBySubItem);
  },
  watch: {
    selectedGroupBy(val) {
      this.setSelectedGroupByPanel(val);
    },
    selectedGroupByItem(val) {
      this.setSelectedGroupByItemPanel(val);
    },
    selectedGroupBySubItem(val) {
      this.setSelectedGroupBySubItemPanel(val);
    },
    panel(val) {
      if (typeof val == "number") {
        this.$emit("selectedgroupByItemChange", val);
      }
    },
    subPanel(val) {
      if (typeof val == "number")
        this.$emit("selectedgroupBySubItemChange", val);
    },
    highlightText(val) {
      if (val && !this.panel) {
        this.panel = 0;
      }
    }
  },
  computed: {
    ...mapState("menu", ["categories", "menuUploadList"])
  },
  methods: {
    ...mapActions("menu", ["getCategories", "deleteCategory"]),
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_PROP"]),
    setCurrentMinute() {
      const date = new Date();
      this.currentMinute = new Date().getHours() * 60 + new Date().getMinutes();
    },
    setSelectedGroupByPanel(val) {
      if (this.selectedGroupByItem == null) {
        this.panel = 0;
      }
    },
    setSelectedGroupByItemPanel(val) {
      if (val == null) {
        this.panel = 0;
      } else {
        this.panel = val;
      }
      if (
        this.groupedItems[val] &&
        this.groupedItems[val].subcategories &&
        this.groupedItems[val].subcategories.length
      ) {
        this.subPanel = [
          ...Array(this.groupedItems[val].subcategories, length).keys()
        ];
        this.expandAllSub = true;
      } else {
        this.expandAllSub = false;
      }
    },
    setSelectedGroupBySubItemPanel(val) {
      this.subPanel = val;
      this.expandAllSub = false;
    },
    handleShowRemoveModifyItemDialog(item) {
      this.showExpansionContent = true;
      this.selectedItem = item;
    },
    handleCategoryOptionClick(category) {
      this.showCategoryOptionsDialog = true;
      this.selectedCategory = { ...category };
    },
    handleAddSubcategory(category) {
      this.selectedSubCategory = {};
      this.selectedCategory = { ...category };
      this.showSubCategoryDialog = true;
      this.showCategoryOptionsDialog = false;
    },
    handleUpdateCategory(category) {
      this.selectedCategory = category;
      this.showCategoryDialog = true;
      this.showCategoryOptionsDialog = false;
    },
    handleDeleteCategory(category) {
      this.selectedCategory = category;
      this.showCategoryOptionsDialog = false;
      this.showDeleteCategoryDialog = true;
    },
    async triggerDeleteCategory(data) {
      this.deleteLoading = true;
      if (data.selectedOption === "deleteAndMove") {
        this.moveItemsToCategory(data.selectedCategory);
      }
      await this.getCategoryDeleted(this.selectedCategory);
      this.deleteLoading = false;
      this.showDeleteCategoryDialog = false;
    },
    shouldShowCategoryOptions(index, item) {
      if (
        this.selectedGroupBy == "category" &&
        Array.isArray(this.panel) &&
        this.panel.includes(index) &&
        !this.$vuetify.breakpoint.mdAndUp &&
        item.id != "all-items" &&
        item.id != "todays-special" &&
        item.id != "recommended-items" &&
        item.id != "combos"
      ) {
        return true;
      }
      return false;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
